import React from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import PropTypes from "prop-types"

//i18n
import { withTranslation } from "react-i18next"
import { CustomButton } from "../Button"

const ConfirmModal2 = ({
  modal,
  onToggle,
  onConfirm,
  message,
  title,
  btnConfirmText,
  t,
  isEdit,
}) => {
  return (
    <Modal centered={true} scrollable={true} isOpen={modal}>
      <ModalHeader toggle={onToggle} tag="h5">
        {title}
      </ModalHeader>
      <ModalBody>
        <Row>
          <div className="text-center">{message}</div>
        </Row>
      </ModalBody>
      <ModalFooter>
        <CustomButton
          type="button"
          onClick={onToggle}
          className="btn btn-secondary button-width"
          data-dismiss="modal"
        >
          {t("Cancel")}
        </CustomButton>
        <CustomButton
          type="button"
          onClick={() => {
            onConfirm()
          }}
          className="btn btn-info save-user button-width"
          isEdit={true}
        >
          {t(btnConfirmText)}
        </CustomButton>
      </ModalFooter>
    </Modal>
  )
}

ConfirmModal2.propTypes = {
  onConfirm: PropTypes.func,
  onToggle: PropTypes.func,
  modal: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  btnConfirmText: PropTypes.string,
  t: PropTypes.any,
}
ConfirmModal2.defaultProps = {
  onConfirm: () => { },
  onToggle: () => { },
  title: "title",
  message: "message",
  btnConfirmText: "OK",
}

export default withTranslation(["common"])(ConfirmModal2)
